<template>
  <ImportExport :title="$t('keywords.workflow')" type="workflows" :headers="headers" v-on="$listeners">
    <template #item.workflowName="{ item }">
      <v-text-field v-model="item.workflowName" :rules="alphaNumericRules(item.workflowName)" style="margin-bottom: -2.3vh" outlined dense />
    </template>

    <template #item.active="{ item }">
      <v-switch v-model="item.active" />
    </template>

    <template #item.routingkey="{ item }">
      <RoutingkeySelect v-model="item.routingkey" style="width: 10.5vw; margin-bottom: -3%" :rules="requiredRules(item.routingkey)" hint="" />
    </template>
  </ImportExport>
</template>

<script>
import ImportExport from '../core/ImportExport.vue'
import RoutingkeySelect from '../core/RoutingkeySelect.vue'
import { alphaNumericRules, requiredRules } from '../../utils/rules'
import LocalStorageService from '../../services/LocalStorageService'

export default {

  components: { ImportExport, RoutingkeySelect },

  data: () => ({
    alphaNumericRules,
    requiredRules
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('workflow.form.workflow_name'),
          value: 'workflowName'
        },
        {
          text: this.$t('check.active'),
          value: 'active'
        },
        {
          text: this.$t('workflow.form.integration_type'),
          value: 'integrationType'
        },
        {
          text: this.$t('core.routing_key'),
          value: 'routingkey',
          show: LocalStorageService.isPlatform()
        }
      ].filter(i => i.show ?? true)
    }
  }

}
</script>
